import { Controller } from "stimulus";
import * as CodeMirror from "codemirror";
import "codemirror/mode/xml/xml.js";

export default class extends Controller {
  static targets = ["textarea"];

  connect() {
    CodeMirror.fromTextArea(this.textareaTarget, {
      lineNumbers: true,
      mode: "xml",
      htmlMode: true,
      theme: "lesser-dark",
    });
  }
}
